import EternaLifeLogo from '@/assets/logos/eterna-life.svg?react';
import { routes } from '@/routes/routes';
import { Menu as MenuIcon } from '@carbon/icons-react';
import { Link } from '@tanstack/react-router';
import { useState } from 'react';
import { Button } from '../common/Button';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTrigger,
} from '../common/Drawer';

interface HeaderDrawerProps {
  logoHref?: string;
  children?: React.ReactNode;
}

export const HeaderDrawer = ({
  logoHref = routes.home,
  children,
}: HeaderDrawerProps) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Drawer direction="right" open={drawerOpen} onOpenChange={setDrawerOpen}>
      <DrawerTrigger asChild>
        <Button size="icon" className="lg:hidden">
          <MenuIcon className="size-6" />
        </Button>
      </DrawerTrigger>

      <DrawerContent>
        <DrawerHeader className="mt-8">
          <DrawerClose asChild>
            <Link to={logoHref}>
              <EternaLifeLogo className="text-secondary mx-auto w-30" />
            </Link>
          </DrawerClose>
        </DrawerHeader>

        <div className="flex flex-col gap-4 p-4">{children}</div>
      </DrawerContent>
    </Drawer>
  );
};
